import Vue from 'vue'
import http from '@/services/http.service'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.service) this.$service = options.service
    else if (options.parent && options.parent.$service)
      this.$service = options.parent.$service
  },
})

export default {
  async getServices() {
    const response = await http.get(`/services`)
    return response.data
  },
}
